module.exports = __webpack_public_path__ + "img/DE01779.7915b9da.png";